import { Injectable } from '@angular/core';
import { AngularFireDatabase  } from 'angularfire2/database/database';
//import { DateTime } from 'ionic-angular';
//import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { AuthProvider } from '../providers/auth/auth';
//import { DatePipe } from '@angular/common';

@Injectable()
export class PartesService{
  constructor(public afDB: AngularFireDatabase,public auth : AuthProvider,){
    this.usuario =  this.getUsuario();
    //this.getTodoPersonal();
    /*this.getPersonal()
        .subscribe(personal => {
            this.personal = personal;
        });*/
  }

  usuario : string;
  personal = [];
  fichadas = [];
  public temparr = [];
  NombreUsuario : '';  
 // pipe = new DatePipe('en-US');
  fecha = '';

  public editFichada(fichada, fecha, ficha){
    this.afDB.database.ref('/fichadas/' + this.usuario + '/' + fecha.substring(0,4) + '/' + fecha.substring(5,7) + '/' + fecha + '/' + ficha).set(fichada);
  }
  //Añadir,editar y eliminar Partes    
  
      public editParte(parte){
        this.afDB.database.ref('/encargados/' + this.usuario + '/partes/' + parte.id).set(parte);
      } 

      public deleteParte(parte){
        this.afDB.database.ref('/encargados/' + this.usuario + '/partes/' + parte.id).remove();
      }

    public getFichadasOrdenado(Fecha){
      return this.afDB.list('/fichadas/' + this.usuario + '/'+ Fecha.substring(0,4) + '/' + Fecha.substring(5,7) + '/'  + Fecha + '/',{query:{orderByChild: 'Ficha'}});
    }

      public refreshPersonal(idCuadrilla){
        this.getPersonalCuadrilla(idCuadrilla)
        .subscribe(personal => {
            this.personal = personal;
        });
      }
      
      public getNombre(id){
        let Nombre : string;
        Nombre = "";
        this.afDB.database.ref('/personal/').orderByChild('uid').once('value', snapshot => {
          let catData = snapshot.val();
          let temparr = [];
          for (var key in catData) {
            for (var key2 in catData[key]) { // <= for nuevo
              if(catData[key][key2].id == id) Nombre = catData[key][key2].Nombre; 
            }
          }
                 
      });
      return Nombre;   
      }

      public getTodoPersonal(){
        let Nombre : string;
        Nombre = "";
        this.afDB.database.ref('/personal/').orderByChild('uid').once('value', snapshot => {
          let catData = snapshot.val();
          let temparr = [];
          for (var key in catData) {
            for (var key2 in catData[key]) { // <= for nuevo
              this.temparr.push(catData[key][key2]) 
            }
          }
                 
      });}

      /*public getTodoPersonal(){
        return this.afDB.list('/personal/');
      }*/

      public getPersonal(){
        return this.afDB.list('/cuadrillas/' + this.usuario + '/personal/');
      }

      public getPersonalCuadrilla(idCuadrilla){
        return this.afDB.list('/personal/'+ idCuadrilla +'/',{query:{orderByChild: 'Nombre'}});
      }
         
      public getCuadrillas(){
        return this.afDB.list('/cuadrillas/',{query:{orderByChild: 'id'}});
      }  

      public getUsuario(){
        let strUsuario : string;
        strUsuario = this.auth.getUser();
        strUsuario = strUsuario.substring(0,3);
        return strUsuario;
      }


      public getFichadas(Fecha){
        //console.log('/fichadas/' + this.usuario + '/'+ Fecha.substring(0,4) + '/' + Fecha.substring(5,7) + '/' + Fecha + '/');
        return this.afDB.list('/fichadas/' + this.usuario + '/'+ Fecha.substring(0,4) + '/' + Fecha.substring(5,7) + '/' + Fecha + '/');
      }    
  
  //Metodos set...
  public setUsuario(item,fecha){
    this.usuario = item.id;
    //var Fecha = this.pipe.transform(Date.now(), 'yyyy-MM-dd');   
    //console.log(fecha);


    this.getPersonal()
    .subscribe(personal => {
      this.personal = personal;
    });

    this.getFichadas(fecha)
    .subscribe(fichadas => {
      this.fichadas = fichadas;
        }); 
    
    this.fecha = fecha;    
    this.NombreUsuario = item.Nombre; 
    console.log(this.fecha + ' - ' + this.NombreUsuario);
  }

  public getFecha(){
    return this.fecha;
  }
}


// WEBPACK FOOTER //
// ./src/services/partes.services.ts